import { OwaWorkload } from 'owa-workloads';

export const SupportedWorkLoads =
    OwaWorkload.FilesHub | OwaWorkload.People | OwaWorkload.Mail | OwaWorkload.Calendar;
